<script setup>
import { onMounted, ref, reactive } from 'vue'
import router from '@/router'
import { getTreeCategoryListAPI } from "@/apis/category"
import { useCartStore } from '@/stores/cartStore'
import { useI18n } from 'vue-i18n'
import { useUserStore } from '@/stores/userStore';
import { goUp, goRate, exchangeRate, valueRange } from "@/utils/index";
import categoryHeader from '../Layout/components/categoryHeader.vue';

const { t } = useI18n();
const userStore = useUserStore()
const cartStore = useCartStore()
// const categoryData = reactive([
//     { name: '111', check: false },
//     { name: '2222', check: true },
//     { name: '333', check: false },
//     { name: '333', check: false },
//     { name: '333', check: false },
//     { name: '444', check: false }
// ]);
const categorySecondData = reactive([]);

const selectIndex = ref(0)

const selectOne = (i) => {
    selectIndex.value = i
}
const toSearch=(i,f)=>{
    localStorage.setItem('selectCategoryIndex',  selectIndex.value)
    router.push({ path: '/category/sub/3/' + i.id,query:{name:i.name,fname:f.name}})
}
// 获取数据
const categoryData = ref({})
const getCategory = async () => {
    const res = await getTreeCategoryListAPI()
    categoryData.value = res.data
    selectIndex.value =localStorage.getItem('selectCategoryIndex')||0
    localStorage.removeItem('selectCategoryIndex')
}
onMounted(() => {
    getCategory()
})

</script>

<template>
    <div class="category">
        <categoryHeader class="phone"/>

        <div class="category-l">
            <div class="menu-group" v-for="(i, index) in categoryData.data">
                <div class="menu-item" :class="selectIndex == index ? 'select-item' : ''" @click="selectOne(index)">
                    <div class="item-text">{{ i.name }}</div>
                    <div class="sel-icon"></div>
                    <div v-if="selectIndex == index" class="sel-circle sel-top">
                        <div>
                            <div></div>
                        </div>
                    </div>
                    <div v-if="selectIndex == index" class="sel-circle sel-bottom">
                        <div>
                            <div></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="category-r">
            <img v-if="categoryData && categoryData.data && categoryData && categoryData.data[selectIndex].image" class="top-image" :src="categoryData.data[selectIndex].image" alt="缩略图" />
            <!-- {{ categoryData&&categoryData.data?categoryData.data[selectIndex]:'0' }} -->
            <div v-if="categoryData && categoryData.data && categoryData && categoryData.data[selectIndex].children"
                class="category-group">
                <div v-for="(i, index) in categoryData.data[selectIndex].children" class="category-item" @click="toSearch(i,categoryData.data[selectIndex])" :key="index">
                    <div class="img-box">
                    <img :src="i.image" alt="" /></div>
                    <div>{{ i.name }}</div>
                </div>
                <div class="category-item category-item-none"></div>
                <div class="category-item category-item-none"></div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.pc {
    display: block;
}

.phone {
    // display: none;
}

.container {
    width: 100%;
}

.category {
    background: #F8F8F8;
    color: #666;
    padding-top: 58px;
    padding-bottom: 70px;
    height: 100vh;
    display: flex;

    .category-l {
        width: 110px;
        overflow-y: scroll;

        .menu-group {
            .menu-item {

                height: 50px;
                line-height: 34px;
                text-align: center;
                padding: 8px;
                box-sizing: border-box;
                font-weight: 400;
                font-size: 12px;
                color: #666666;
                font-style: normal;
                
                .item-text{
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }

            .select-item {
                color: #FC3938;

                font-size: 14px;
                font-weight: 600;
                position: relative;
                background-color: #fff;

                .sel-icon {
                    position: absolute;
                    left: 0;
                    top: 13px;
                    width: 4px;
                    height: 24px;
                    background: #FC3938;
                    border-radius: 2px;
                }

                .sel-circle {
                    position: absolute;
                    right: 0;
                    background-color: #fff;
                    width: 20px;
                    height: 20px;
                    overflow: hidden;

                    >div {
                        width: 40px;
                        height: 40px;

                        >div {
                            width: 40px;
                            height: 40px;
                            border-radius: 50%;
                            background-color: #F8F8F8;
                        }
                    }
                }

                .sel-bottom {
                    bottom: -20px;
                    transform: rotate(90deg);
                }

                .sel-top {
                    top: -20px;
                    transform: rotate(-180deg);
                }
            }

        }

    }

    .category-r {
        flex: 1;
        background-color: #fff;
        overflow-y: scroll;
        padding: 17px 15px;
        box-sizing: border-box;
        .top-image{
            width: 100%;
            margin-bottom: 15px;
            height: 80px;
            object-fit: cover;
            border-radius: 10px;
        }
        .category-group {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;

            .category-item {
                width: 33%;
                padding: 10px 18px 0;
                box-sizing: border-box;
                // height: 78px;
                display: flex;
                flex-direction: column;
                align-items: center;
                .img-box{
                    width:100%;
                    height: 0;
                    position: relative;
                    padding-top: 100%;
                    >img {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        // width: 47px;
                        // height:47px;
                    }
                }
               

                >div {
                    font-weight: 400;
                    font-size: 10px;
                    color: #555555;
                    font-style: normal;
                    padding: 5px 0;
                }
            }
            .category-item-none{
                width: 33%;
                padding: 0;
            }
        }
    }

}
</style>